<template>
  <div id="musicAdd">
     <v-container class="pa-0">
      <v-layout style="min-height:70px;">
      <v-flex md6>
        <v-btn fab absolute to="/music" class="ml-3 pf-btn-fab">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
        <v-flex offset-md1 md5 v-if="selectedData">
        <div style="float:right">
          <v-btn class="pf-btn pf-btn-cancel" to="/music">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
     </v-container>
    <v-form ref="musicAdd">
      <v-container>
        <v-layout wrap row>
          <v-flex class="xs12 sm6 md7">
            <v-text-field 
                label="Music Name" 
                v-model.trim="musicName" 
                class="required pr-4 pl-4"
                :rules="musicNameRules"
                @input="changedData"></v-text-field>
          </v-flex>
          <v-flex class="xs12 sm6 md7">
            <upload-btn @file-update="fileSelected($event)" ripple noTitleUpdate :title="title" maxWidth="200px">
            <template slot="icon">
                <v-icon right dark>cloud_upload</v-icon>
            </template>
            <template slot="text-field"></template>
            </upload-btn>
          </v-flex>
      </v-layout>
      </v-container>
    </v-form>
      <v-layout class="editor-button-container">
        <v-flex xs12 class="button-container text-xs-right" v-if="selectedData">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" to="/music">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
/* global session store config */  
import { getCollection, remove, uploadFile, formatDate } from '../../helpers/helpers';
import UploadButton from 'vuetify-upload-button';
import swal from 'sweetalert2';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { file } from '@babel/types';

export default {
  name: 'MusicAdd',
  components: {
    'upload-btn': UploadButton,
  },  
  data: () => ({
    entity: 'Music',
    title: 'Select File',
    musicName: '',
    extraParams: {},
    uploadingFile: {},
    config: config,
    selectedData: false,
    musicNameRules: [
      v => !!v || 'File name is required'
    ]
  }),
  computed: {
    Music: {
      get () {
        return store.state.Music;
      },
      set (value) {
        store.commit('setMusic', value);
      }
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    window.getApp.$emit('pageSubHeader', 'Add');
    this.getMusic();
  },
  methods: {
    async getMusic () {
      if (!this.Music.length) {
        let { error, data } = await getCollection(this.entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Music = data;
          }
        }
      }
    },
    async fileSelected (files) {
      this.selectedData = true;
      this.uploadingFile = files;
      let type = '';
      if (this.uploadingFile && this.uploadingFile.type) {
        type = this.uploadingFile.type.split('/')[0];
      }
      if (type === 'audio') {
        this.title = this.uploadingFile.name;
      } else {
        this.title = 'Select File';
        this.uploadingFile = {};
        swal.fire({
          title: `<strong>Invalid File</strong>`,
          type: 'error',
          html: `The selected file should be an audio`,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close',
        });
        return;
      }
    },
    async save () {
      if (!this.uploadingFile.name) {
        swal.fire({
          title: `<strong>No file selected</strong>`,
          type: 'error',
          html: 'Please select the audio file',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close',
        });
        return;
      }
      if (this.$refs.musicAdd.validate()) {
        this.selectedData = false;
        let files = this.uploadingFile;
        if (files.size > this.config.uploadFileSize) {
          swal.fire({
            title: `<strong>Upload error</strong>`,
            type: 'error',
            html: 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB',
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: 'Close',
          });
          this.selectedData = true;
          return;
        }
        window.getApp.$emit('AppProgress', true);
        const fr = new FileReader();
        fr.readAsDataURL(files);
        fr.addEventListener('load', async () => {
          this.extraParams = {
            name: this.musicName
          };
          let postUrl = 'Music';
          let response = await uploadFile(postUrl, files, 'POST', this.extraParams);
          if (!response.$data) {
            window.getApp.$emit('AppProgress', false);
            console.log('error', response.$error);
            this.selectedData = true;
            this.snackbar = {
              show: true,
              color: 'red',
              text: response.$error
            };
          } else {
            this.Music.push(response.$data);
            swal.fire({
              type: 'success',
              title: 'Music saved successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                window.getApp.$emit('AppProgress', false);
                this.$router.push({ path: '/music' });
              }
            });
          }
        });
      }
    },
    changedData () {
      this.selectedData = true;
    }
  }
};
</script>

<style lang="css" scoped>
  .editor-button-container{
    padding-top: 70px;
  }
  #musicAdd >>> .primary {
    background-color: #7ac142 !important;
    border-color:#7ac142 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Music/add.vue